function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)",
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 62.0235V14.0926C21.9689 12.4653 48.0518 11.4297 56.6321 20.3058C65.2124 29.1819 89.1192 19.862 100 14.0926V58.9169C90.0518 61.2838 66.9845 64.5976 54.3005 58.9169C41.6166 53.2362 19.4819 58.621 10 62.0235Z",
  fill: "#00B074"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 10,
  y: 12,
  width: 90,
  height: 50
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 61.0235V13.0926C21.9689 11.4653 48.0518 10.4297 56.6321 19.3058C65.2124 28.1819 89.1192 18.862 100 13.0926V57.9169C90.0518 60.2838 66.9845 63.5976 54.3005 57.9169C41.6166 52.2362 19.4819 57.621 10 61.0235Z",
  fill: "#94F7B8"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50.705 52.2209L44.3344 58.2118C44.3344 58.2118 38.0865 42.1348 25.9682 37.0665C13.85 31.9982 7.6021 15.9213 7.6021 15.9213L13.9727 9.93042C13.9727 9.93042 22.6069 27.4219 31.4897 31.8741C40.3726 36.3263 50.705 52.2209 50.705 52.2209Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.2955 15.3911C12.3299 18.7882 10.5588 18.7108 20.5651 27.8793C29.6296 36.1849 34.0201 34.1775 46.038 52.8751",
  stroke: "#652DD0",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "2 8"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask1",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 10,
  y: 12,
  width: 90,
  height: 50
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 61.0235V13.0926C21.9689 11.4653 48.0518 10.4297 56.6321 19.3058C65.2124 28.1819 89.1192 18.862 100 13.0926V57.9169C90.0518 60.2838 66.9845 63.5976 54.3005 57.9169C41.6166 52.2362 19.4819 57.621 10 61.0235Z",
  fill: "#883B16"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M100 39.3499L100 54.0285C100 54.0285 74.2857 44.2427 55 54.0285C35.7143 63.8143 10 54.0285 10 54.0285L10 39.3499C10 39.3499 40 47.6674 55 41.3062C70 34.9451 100 39.3499 100 39.3499Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.4468 48.7609C18.5656 51.191 16.524 53.352 38.2861 50.7613C58 48.4144 60.4849 40.635 95.6251 45.9898",
  stroke: "#652DD0",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "4 8"
}))));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M58.9148 15.5121C58.9148 22.8928 49.694 33.5471 47.1403 36.3563C46.7866 36.7453 46.1966 36.7453 45.8429 36.3563C43.2892 33.5471 34.0684 22.8928 34.0684 15.5121C33.2401 5.17069 40.0878 0 46.4916 0C52.8954 0 58.9148 5.17069 58.9148 15.5121Z",
  fill: "#CFABFA"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 45.7975,
  cy: 13.0325,
  rx: 5.79751,
  ry: 6.03247,
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 7,
  width: 110,
  height: 89,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 90,
  height: 69,
  fill: "white",
  transform: "translate(10 13)"
})));

var SvgMapIcon = function SvgMapIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 82,
    viewBox: "0 0 89 82",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMapIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map-icon.1cfaaa80.svg";
export { ForwardRef as ReactComponent };